import React, { useState } from 'react';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import Fingerprint from '@/component/icons/sf-fingerprint';
import Face from '@mui/icons-material/Face';
import SFCheckCircleIcon from '../icons/sf-check-circle-icon';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import SFFaceIcon from '../icons/sf-face-icon';

type SuccessDrawerProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
};

function SuccessDrawer({ open, onClose, title, content }: SuccessDrawerProps) {
  const theme = useTheme();

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          p: 3,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
        }}
      >
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 0, top: 0, p: 0 }}>
          <Close />
        </IconButton>

        <Box>
          <Typography variant="h5" fontWeight={700} mb={5}>
            {title}
          </Typography>
          <Stack alignItems="center" gap={3}>
            <SFCheckCircleIcon color={theme.palette.primary.main} strokeWidth={1.5} style={{ fontSize: 60 }} />
            <Typography variant="body1" color="primary" fontWeight={700}>
              {content}
            </Typography>
          </Stack>
        </Box>
      </Box>
    </Drawer>
  );
}

export default SuccessDrawer;
